import { documentsConstants } from "../constants";

export const Document = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.DOCUMENTS_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.DOCUMENTS_SUCCESS:
      return { loading: false, items: action.document.Body, error: undefined };

    case documentsConstants.DOCUMENTS_FAILURE:
      return { loading: false, items: undefined, error: action.error };
    
      case documentsConstants.DOCUMENTS_RESET:
      return {
        loading: false,
        items: undefined,
        error: undefined
      }
    default:
      return state;
  }
};

export const DocumentUpload = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.DOCUMENTS_UPLOAD_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.DOCUMENTS_UPLOAD_SUCCESS:
      return {
        loading: false,
        items: action.documentUpload.Body,
        error: undefined,
      };

    case documentsConstants.DOCUMENTS_UPLOAD_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    default:
      return state;
  }
};

export const DocumentUploadEvidence = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.DOCUMENTS_EVIDENCE_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.DOCUMENTS_EVIDENCE_SUCCESS:
      return {
        loading: false,
        items: action.documentUploadEvidence.Body,
        error: undefined,
      };

    case documentsConstants.DOCUMENTS_EVIDENCE_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    default:
      return state;
  }
};

export const UploadSections = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.UPLOAD_SECTION_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.UPLOAD_SECTION_SUCCESS:
      return {
        loading: false,
        items: action.uploadSecData.Body,
        error: undefined,
      };

    case documentsConstants.UPLOAD_SECTION_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    case documentsConstants.UPLOAD_SECTION_RESET:
      return { loading: false, items: null, error: null };

    default:
      return state;
  }
};

export const UploadDocuments = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.UPLOAD_DOCUMENTS_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.UPLOAD_DOCUMENTS_SUCCESS:
      return {
        loading: false,
        items: action.uploadDocsData.Body,
        error: undefined,
      };

    case documentsConstants.UPLOAD_DOCUMENTS_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    default:
      return state;
  }
};

export const OcrData = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.GET_OCRDATA_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.GET_OCRDATA_SUCCESS:
      return {
        loading: false,
        items: action.ocrData.Body,
        error: undefined,
      };

    case documentsConstants.GET_OCRDATA_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    default:
      return state;
  }
};

export const MetadaData = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.REGISTER_DATA_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.REGISTER_DATA_SUCCESS:
      return {
        loading: false,
        items: action.metaData.Body,
        error: undefined,
      };

    case documentsConstants.REGISTER_DATA_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    default:
      return state;
  }
};

export const DocumentView = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.GET_DOCUMENTS_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.GET_DOCUMENTS_SUCCESS:
      return {
        loading: false,
        items: action.getDoc.data,
        itemsURL: action.getDoc.url,
        type: action.getDoc.type,
        extension: action.getDoc.extension,
        dataBlob: action.getDoc.dataBlob,
        error: undefined,
      };

    case documentsConstants.GET_DOCUMENTS_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    default:
      return state;
  }
};

export const AutographSign = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.AUTOGRAPH_SIGN_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.AUTOGRAPH_SIGN_SUCCESS:
      return { loading: false, items: action.response.Body, error: undefined };

    case documentsConstants.AUTOGRAPH_SIGN_FAILURE:
      return { loading: false, items: undefined, error: action.error };
    case documentsConstants.AUTOGRAPH_SIGN_RESET:
      return {
        loading: false,
        items: undefined,
        error: undefined
      }

    default:
      return state;
  }
};

export const FacialComparison = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.FACIAL_COMPARISON_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.FACIAL_COMPARISON_SUCCESS:
      return { loading: false, items: action.facialResult.Body, error: undefined };

    case documentsConstants.FACIAL_COMPARISON_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    case documentsConstants.FACIAL_COMPARISON_RESET:
      return { loading: false, items: null, error: null };

    default:
      return state;
  }
};

export const RegisteredData = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.REGISTERTWO_DATA_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.REGISTERTWO_DATA_SUCCESS:
      return { loading: false, items: action.registeredData.Body, error: undefined };

    case documentsConstants.REGISTERTWO_DATA_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    default:
      return state;
  }
};

export const ValIdentityData = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.VALIDATEDENTITY_DATA_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.VALIDATEDENTITY_DATA_SUCCESS:
      return { loading: false, items: action.valIndetityData.Body, error: undefined };

    case documentsConstants.VALIDATEDENTITY_DATA_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    default:
      return state;
  }
};

export const GetValIdentityData = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.GETVALIDATEDENTITY_DATA_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.GETVALIDATEDENTITY_DATA_SUCCESS:
      return { loading: false, items: action.getValIndetityData.Body, error: undefined };

    case documentsConstants.GETVALIDATEDENTITY_DATA_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    default:
      return state;
  }
};

export const UploadDocSectionContent = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.UPLOAD_DOCUMENT_SECTION_CONTENT_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.UPLOAD_DOCUMENT_SECTION_CONTENT_SUCCESS:
      return { loading: false, items: action.updateSectionData, error: undefined };

    case documentsConstants.UPLOAD_DOCUMENT_SECTION_CONTENT_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    default:
      return state;
  }
}

export const UploadVideoEvidenceContentJsonResult = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.UPLOAD_VIDEO_EVIDENCE_JSON_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.UPLOAD_VIDEO_EVIDENCE_JSON_SUCCESS:
      return { loading: false, items: action.uploadVideoJson, error: undefined };

    case documentsConstants.UPLOAD_VIDEO_EVIDENCE_JSON_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    default:
      return state;
  }
}

export const UploadMinutiaData = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.UPLOAD_MINUTIAE_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.UPLOAD_MINUTIAE_SUCCESS:
      return { loading: false, items: action.uploadMinutiaeData.Body, error: undefined };

    case documentsConstants.UPLOAD_MINUTIAE_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    default:
      return state;
  }
}

export const DigitSingSATData = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.DIGITAL_SING_SAT_DOC_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.DIGITAL_SING_SAT_DOC_SUCCESS:
      return { loading: false, items: action.digitSATData.Body, error: undefined };

    case documentsConstants.DIGITAL_SING_SAT_DOC_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    default:
      return state;
  }
}

export const CargaDocWithSecData = (state = {}, action) => {
  switch (action.type) {
    case documentsConstants.CARGADOC_WITH_SECTION_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case documentsConstants.CARGADOC_WITH_SECTION_SUCCESS:
      return { loading: false, items: action.cargaDocData.Body, error: undefined };

    case documentsConstants.CARGADOC_WITH_SECTION_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    default:
      return state;
  }
}